import { useState } from 'react';
import { useFontSize } from '../../context/FontSizeContext';
import { useSoundEngine } from '../../hooks/useSoundEngine';
import { CalibrationView } from './CalibrationView';
import '../../pages/MultiplayerLobby.css';
import './FontSizeModal.css';

const ROLES = [
  { value: 'giver1', label: 'Speaker 1', icon: '🗣️', desc: 'Dai gli indizi per primo' },
  { value: 'giver2', label: 'Speaker 2', icon: '🎙️', desc: 'Dai gli indizi per secondo' },
  { value: 'guesser', label: 'Guesser', icon: '🎯', desc: 'Ascolta e indovina la parola' },
];

export const FontSizeModal = () => {
  const { fontSize, increaseFontSize, decreaseFontSize, resetFontSize, isModalOpen, closeModal } =
    useFontSize();
  const sound = useSoundEngine();
  const [audioTesting, setAudioTesting] = useState(false);
  const [view, setView] = useState('calibration'); // 'calibration' or 'lobby'

  const handleTestAudio = () => {
    if (audioTesting) return;
    setAudioTesting(true);
    sound.playCorrect();
    setTimeout(() => sound.playNewWord(), 350);
    setTimeout(() => sound.playStop(), 700);
    setTimeout(() => sound.playGameEnd(), 1100);
    setTimeout(() => setAudioTesting(false), 2000);
  };

  const handleSave = () => {
    localStorage.setItem('calibration-completed', 'true');
    closeModal();
  };

  if (!isModalOpen) return null;

  const fakePlayers = [
    { name: 'Tu (Alex)', role: 'giver1' },
    { name: 'Mario', role: 'guesser' },
    { name: 'Luigi', role: null },
  ];

  return (
    <div className="fs-modal-overlay">
      <div className="fs-modal-content">
        {/* Floating Controls */}
        <div className="fs-floating-controls">
          <div className="fs-floating-controls__info">
            <span>Altezza: {fontSize}%</span>
          </div>
          <div className="fs-floating-btn-group">
            <button className="fs-btn-mini" onClick={decreaseFontSize} title="Diminuisci Altezza">
              ➖
            </button>
            <button className="fs-btn-mini" onClick={resetFontSize} title="Resetta">
              🔄
            </button>
            <button className="fs-btn-mini" onClick={increaseFontSize} title="Aumenta Altezza">
              ➕
            </button>
          </div>
          <button
            className={`fs-audio-btn ${audioTesting ? 'fs-audio-btn--playing' : ''}`}
            onClick={handleTestAudio}
            id="btn-test-audio"
            title="Testa l'audio"
          >
            {audioTesting ? '🎵' : '🔊'}
          </button>
          <button className="fs-done-btn" onClick={handleSave}>
            SALVA
          </button>
        </div>

        <div className="fs-full-preview">
          <div className="calibration-info">
            <h2 className="calibration-info__title">CALIBRAZIONE SCHERMO</h2>
          </div>

          <button 
            className="fs-view-toggle"
            onClick={() => setView(v => v === 'calibration' ? 'lobby' : 'calibration')}
            title="Cambia anteprima"
          >
            {view === 'calibration' ? '🎮 Mostra Gioco' : '🎯 Mostra Calibrazione'}
          </button>

          {view === 'calibration' ? (
            <CalibrationView />
          ) : (
            <div className="lobby-page lobby-page--room u-fade-in" style={{ pointerEvents: 'none', filter: 'grayscale(1)' }}>
              <header className="lobby-room-header-top">
                <div className="lobby-room-code-card">
                  <p className="lobby-room-label">CODICE STANZA</p>
                  <h1 className="lobby-room-code">K9X4</h1>
                </div>
              </header>

              <div className="lobby-layout-split">
                <section className="lobby-panel-side lobby-panel-side--left">
                  <div className="section-v">
                    <h2 className="panel-title">Giocatori</h2>
                    <div className="lobby-players-vertical">
                      {[0, 1, 2].map((i) => {
                        const p = fakePlayers[i];
                        return (
                          <div
                            key={i}
                            className={`player-slot-v ${p ? 'player-slot-v--filled' : ''}`}
                          >
                            <div className="player-slot-v__avatar">
                              {p ? p.name.charAt(0).toUpperCase() : '?'}
                            </div>
                            <div className="player-slot-v__info">
                              <span className="player-slot-v__name">{p ? p.name : 'Libero'}</span>
                              {p?.role ? (
                                <span className="player-slot-v__role">
                                  {ROLES.find((r) => r.value === p.role)?.label}
                                </span>
                              ) : null}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </section>

                <section className="lobby-panel-side lobby-panel-side--right">
                  <div className="section-v">
                    <h2 className="panel-title">Scegli Ruolo</h2>
                    <div className="role-grid-v">
                      {ROLES.map((r) => {
                        const selected = r.value === 'giver1';
                        const taken = r.value === 'guesser';
                        return (
                          <div
                            key={r.value}
                            className={`role-card-v ${selected ? 'role-card-v--selected' : ''} ${taken ? 'role-card-v--taken' : ''}`}
                          >
                            <span className="role-card-v__icon">{r.icon}</span>
                            <div className="role-card-v__text">
                              <span className="role-card-v__label">{r.label}</span>
                              <span className="role-card-v__desc">{taken ? `(Mario)` : r.desc}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
